export default __webpack_public_path__ + "static/media/lechera_pizza.0f37c0fc.png";